import './App.css'
import PixelScripts from './components/PixelScripts'
import { ToasterComponent } from './features/toaster/ui/ToasterComponent'

import Aviator from './components/Aviator'

function App() {
    return (
        <div>
            <PixelScripts />
            <Aviator />
            <div id="modals" />
            <ToasterComponent />
        </div>
    )
}

export default App
